import { useCallback } from 'react';
import { useAutomationRuleFormProvider } from 'src/pages/automation-rule/form';
import { actionTypes } from 'src/pages/automation-rule/form/actions';
import { useAutomationRuleActions } from 'src/pages/automation-rule/form/actions/use-actions';
import { conditionTypes, useAutomationRuleConditions } from 'src/pages/automation-rule/form/conditions/use-conditions';
import { triggerTypes, useAutomationRuleTrigger } from 'src/pages/automation-rule/form/trigger/use-trigger';
import { randomStringGenerator } from 'src/pages/automation-rule/form/utils/random-string-generator';

// is not possible check if the parent is resolved because there is no "not-equal" operator 

export function useSetParentWorkItemToInProgressUnlessResolved() {
	const { setTitle } = useAutomationRuleFormProvider();
	const { setTrigger, setTriggerData } = useAutomationRuleTrigger();
	const { setActions} = useAutomationRuleActions();
	const { setConditions } = useAutomationRuleConditions();

	const setParentWorkItemToInProgressUnlessResolved = useCallback(() => {
		setTitle('When any child work item transitions to In Progress, set the parent work item to In Progress, unless the parent is resolved');
		setTrigger(triggerTypes.workItemTransitions);
		setTriggerData({
			workItemTransitions: {
				selectedFrom: ['any'],
				selectedTo: ['In Progress'],
				loading: true,
			},
			workItemIsAssignedTo: null,
			fieldValueChange: null,
			checklistTrigger: null
		});
		setConditions([
			{
				id: randomStringGenerator(),
				condition: conditionTypes.fieldMeetACertainCriteria,
				fieldMeetCertainCriteria: {
					relationship: 'parent-work-item',
					relationshipCheck: 'all',
					workItemField: 'System.State',
					operator: 'SupportedOperations.NotEquals',
					inputValueType: 'select',
					selectValue: ['Done'],
					textValue: '',
					dateTimeValue: {
						type: 'datetime',
						datetime: {
							value: new Date(),
						},
						timeframe: {
							timeNumber: 0,
							timeUnit: 'minutes',
							timeOption: 'ago',
						},
					},
					userFieldValue: [],
					iterationOrAreaPathValue: '',
				},
				checklistCompletedOrNotCompletedCondition: null,
				created_at: new Date(),
			},
		]);
		setActions([
			{
				id: randomStringGenerator(),
				action: actionTypes.editWorkItem,
				editWorkItem: {
					workItemField: 'System.State',
					relationship: 'parent-work-item',
					inputValueType: 'select',
					selectValue: ['In Progress'],
					textValue: '',
					dateTimeValue: {
						type: 'datetime',
						datetime: {
							value: new Date(),
						},
						timeframe: {
							timeNumber: 0,
							timeUnit: 'minutes',
							timeOption: 'ago',
						},
					},
					userFieldValue: [],
					iterationOrAreaPathValue: '',
					copyFieldValue: '',
					fieldActionValue: 'set-value'
				},
				addCommentToWorkItem: null,
				sendNotificationToSlack: null,
				sendEmailNotification: null,
				sendTeamsNotification: null,
				createdAt: new Date()
			},
		]);
	}, []);
  
	return {
		setParentWorkItemToInProgressUnlessResolved,
	};
}